import AbstractProvidedClass from "../../../../shared/AbstractProvidedClass";
import { addSvg } from "../../../../shared/utils";
import { CHANGE_CUSTOM_LABEL, DELETE_CUSTOM_LABEL, NEW_CUSTOM_LABEL } from "../../../../tools/actions/ActionHelper";
import RowHelper from "../../RowHelper";
import NewLabelButton from "./NewLabelButton";

export default class CustomLabelField extends AbstractProvidedClass {
    constructor(provider, label, container, index = null, action = null) {
        super(provider);

        this.container = container;
        this.label = label;
        this.action = action;
        this.editing = false;

        this.createField(container, index);
        this.helper = new RowHelper(provider, this);
        this.helper.createOptions(['edit', 'remove', 'show', 'hide']);

        this.label.visible
            ? this.buttons['show'].hide()
            : this.buttons['hide'].hide();
    }

    createField(container, index) {
        this.labelContainer = this.p.createDiv()
        if (index === null) {
            this.labelContainer.parent(container);
        } else {
            let child = container.elt.children[index];
            container.elt.insertBefore(this.labelContainer.elt, child);
        }
        this.row = this.p.createDiv()
            .parent(this.labelContainer)
            .class('input-search-result')
            .mouseOver(() => this.mouseOver())
            .mouseOut(() => this.mouseOut());
        this.img = this.p.createDiv()
            .parent(this.row)
            .class('btn-icon mar-l-xs move-icon');
        addSvg(this.img, 'price-tag-3-line');
        this.labelText = this.p.createElement('label', this.label.getValue())
            .class('input-search-result-name')
            .parent(this.row);

        this.input = this.p.createInput(this.label.getValue())
            .parent(this.row)
            .class('input-text')
            .attribute('autocomplete', 'off')
            .input(() => this.action.update());
        this.input.elt.onfocus = () => {
            this.enableHotKeys = false;
            this.getTab('info').activeInput = this.input;
        };
        this.input.elt.onblur = () => {
            this.enableHotKeys = true;
            let infoTab = this.getTab('info');
            let activeInput = infoTab.activeInput;
            infoTab.activeInput = activeInput == this.input ? null : activeInput;
            this.toggleEdit();
        }
        this.input.hide();

        this.newCustomLabelButton = new NewLabelButton(
            this.provider,
            this.labelContainer,
            this.label.parent,
            this.label.index + 1,
            this.container
        );
    }

    drag() {
        this.mouseOut();
        this.dragging = true;
    }

    endDrag() {
        this.dragging = false;
    }

    mouseOver() {
        if (this.editing || this.dragging) return;
        this.labelText.hide();
        this.options.show();
    }

    mouseOut() {
        if (this.editing || this.dragging) return;
        this.labelText.show();
        this.options.hide();
    }

    toggleEdit() {
        if (this.editing) {
            this.editing = false;
            this.input.hide();
            this.labelText.show();
            this.action.finish();
            this.action = null;
        } else {
            this.editing = true;
            this.input.show();
            this.input.elt.focus();
            this.input.elt.setSelectionRange(this.input.elt.value.length, this.input.elt.value.length);
            this.labelText.hide();
            this.options.hide();
            this.action = this.action
                ? this.action
                : this.actions.new(
                    CHANGE_CUSTOM_LABEL,
                    this.label, this.input, this.labelText
                );

        }
    }

    toggleVisibility() {
        this.label.visible = !this.label.visible;
        if (this.label.visible) {
            this.buttons['show'].hide();
            this.buttons['hide'].show();
        } else {
            this.buttons['show'].show();
            this.buttons['hide'].hide();
        }
    }

    remove() {
        this.actions
            .new(DELETE_CUSTOM_LABEL, this.selection.first, this.label)
            .finish();
        this.delete();
    }

    delete() {
        this.labelContainer.remove();
    }
}
